import { useParams } from 'react-router-dom';

export interface StudySpaceBaseEventData {
    spaceId: string | undefined;
}

const useStudySpaceBaseEventData = (): StudySpaceBaseEventData => {
    const { spaceId } = useParams();

    if (!spaceId) {
        console.error('No spaceId found in params for analytics study space base event data');
    }

    return { spaceId };
};

export { useStudySpaceBaseEventData };
